import type { Components } from '@mui/material/styles';

export default function MuiAppBar(): Components['MuiAppBar'] {
  return {};
}
